import Vue from 'vue'
import qs from 'qs'
export default {
  namespaced: true,
  getters: {
    getIGSs: state => state.igses
  },
  actions: {
    saveIG (context, ig) {
      return Vue.axios
          .post('/api/ig/save', qs.stringify(ig))
          .then(res => {
            return res.data
          })
    },
    loadIGSs (context) {
      Vue.axios.get('/api/igs/list').then(res => {
        context.commit('IGS_LIST', JSON.parse(res.data.data))
      })
    },

    async loadCasesForIGS (context, igs) {
      return await Vue.axios.get('/api/cases/list', {
        params: {
          ingestionSite: igs
        }
      })
    }
  },
  mutations: {
    IGS_LIST (state, list) {
      state.igses = list
    }
  },
  state: {
    igs: {},
    igses: []
  }
}
